module.exports = __webpack_public_path__ + "bb9f1644c559b8d331b6819232dda318.pdf";